<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img class="white--text" height="400px" src="/images/colette-and-gerard-car.jpg">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span class="grey--text">Question 4</span>
            <br>
            <span>Your 3 year old brother won't leave the house until he is wearing your new dress. Do you?</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="$store.question" :disabled="getShowAnswer">
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:true})"
              label="No way, you ate all my Big Mac, our sharing days are over."
              value="Correct: Boys shouldn't be wearing dresses despite what the social constructionist leftish agenda tells you."
            ></v-radio>
            <v-radio
              @change="updateAnswer({value:$event,isCorrect:false})"
              label="Let him, I'm a kind person who likes to share."
              value="Wrong: Now mum is going to tell everyone this story at my 30 birthday party."
            ></v-radio>
          </v-radio-group>
          <span v-if="getShowAnswer" >{{ getAnswer }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="getAnswer && !getShowAnswer" @click="showAnswer()" >Get Answer</v-btn>
          <v-btn v-if="getShowAnswer" to="/finish" flat color="orange">Next Question</v-btn>
          <v-spacer></v-spacer><span class="grey--text">Current score: {{getScore}}</span>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  methods: mapMutations(['showAnswer', 'updateAnswer', 'nextQuestion']),
  computed: mapGetters(['getScore', 'getAnswer', 'getShowAnswer']),
    created() {
     this.$store.dispatch('resetQuestion');
   },
};
</script>
